export default {
    site: {
        common: {
            hello: "Witaj",
            thankYou: "Dziękuję",
            forMoreInfo: "więcej informacji",
            hoverOverColumnHeaders: "Wskaż kursorem nagłówki kolumn by uzyskać więcej informacji.",
            username: "Imię Gracza",    // WAŻNE !> zanim to zmienisz, przemyśl czy proponowane przez Ciebie wyrażenie będzie 'dobrze działało" w różnych kontekstach, odmieniane przez wszystkie przypadki. Tu podajesz wyrażenie w mianowniku, ale na stronie używane będzie również w innych przypadkach... Dlatego mój wybór to "imię gracza"
            score: "Wynik",
            points: "Punkty",
            pointsAbbreviation: "pkt",
            chapter: "Rozdział",
            tier: "Tier",                //////
            t1: "T1",                    ////
            t2: "T2",                    ///
            t3: "T3",                    //
            collectionsPerDay: "Częstość zbiorów",
            relicBoostPercent: "Bonus z Reliktów",
            mountainHallPercentShort: "Bonus z Górskich Hal",
            updated: "aktualizacja",
            lastUpdated: "Ostatnia aktualizacja",
            created: "utworzono",
            role: "tytuł",
            Fellow: 'Towarzysz',
            Ambassador: 'Ambasador',
            Mage: 'Mag',
            Archmage: 'Arcymag',
            saveChanges: "Zapisz",
            copy: "Kopiuj",
            close: "Zamknij",
            cancel: "Anuluj",
            action: "Akcja",
            date: "Data",
            Left: "Opuścił",
            Joined: "Dołączył",
            human: "Człowiek",
            elf: "Elf",
            search: "Szukaj",
            enter: "Wprowadź",
            yes: "Tak",
            no: "Nie",
            tournament: "Turniej",
            tournaments: "Turnieje",
            fellowship: "Bractwo",
            player: "Gracz",
            member: "Członek",
            history: "Historia",
            tournamentHistory:  "Wyniki Turniejów",    // Niby powinno być coś z historią, ale nie brzmiało mi to za dobrze..
            scoreHistory: "Zmiany Punktów Rankingowych",        // j.w.
            server: "Świat",
            lastWeekGain: "W ciągu tygodnia",    //"Last Week Gain",        //////
            comingSoon: "Wkrótce",
            chest: "Skrzynia",
            yourServer: "Twój serwer",
            allServers: "Wszystkie serwery",
            boosts: "Bonusy",
            marble: "Marmur",
            steel: "Stal",
            planks: "Drewno",
            crystal: "Kryształ",
            scrolls: "Zwoje",
            silk: "Jedwab",
            elixir: "Eliksir",
            magic_dust: "Magiczny Pył",
            gems: "Klejnoty",
            sentient: "Żywe",        //////    ???
            goods: "Towary",        ///////
            average: "Śred.",        /////////
            expansions: 'Ekspansje', // 5x5 grids
            cultureBoostMinimum: 'Minimalna Premia Kultury',        ///////
            cultureBoostCalculated: 'Szacowana Premia Kultury',        ///////
            neighborlyHelp: 'Pomoc sąsiedzka',
            neighborlyHelpAbbreviation: 'PS'        //// ???     Pomoc ??
        },
        // HIGH PRIORITY
        nav: {
            home: "Home",
            players: "Gracze",
            fellowships: "Bractwa",
            tournaments: "Turnieje",
            contact: "Kontakt",
            donate: "Wesprzyj Nas",
            faq: "FAQ",
            news: "Newsy",
            privacyPolicy: "Polityka Prywatności",
            me: "Moje Konto",
            myFellowship: "Moje Bractwo",

            // NOTE USED AT THE MOMENT
            globalStats: "Statystyki globalne",
            articles: "Artykuły",
            fellowshipAdventure: "Przygoda Bractw",
            recruit: "Rekrutuj",
        },
        // VERY HIGH PRIORITY!
        elvenArchitect: {
            viewCityOnElvenArchitect: "Zobacz miasto tego gracza na Elven Architect"
            ,obtainingLink: "Proszę czekać"    // powinno być coś w stylu "Uzyskiwanie linku", ale to dziwnie brzmi
            ,successMessage: "Gotowe! Kliknij link, żeby przejść do Elven Architect"
            ,ageOfLink: "Link pokaże miasto takie, jakie było: "
            ,clickToGetCurrentCity: "<-- Kliknij aby odświeżyć i zobaczyć aktualne miasto",        //////////
        },
        // High Priority
        playerSelection: {
            headline: "Pokaż jako",
            description: "Kliknięcie zaktualizuje różne części strony dopasowane do wybranego użytkownika, takie jak: Moje Bractwo, Moje Konto, Turnieje, Rankingi.",
            youAreViewing: "Obecnie przeglądasz stronę jako {username} na {serverName}.",
            changeUser: "Zmień Gracza",
            enterYourUsernameToGetStarted: "Wprowadź Nazwę Gracza aby rozpocząć",
            thisIsNotASignup: "To nie jest rejestracja.  Podanie Nazwy Gracza ułatwi automatyczne dopasowanie i wyszukiwanie interesujących treści, uprości personalizację dużej części zawartości strony, oraz udostępni do nich aktywne linki."
        },
        searchBoxes: {
            enterFellowshipName: 'Wpisz nazwę bractwa',
            instructions: "Wpisz nazwę i wybierz z listy.",
            noFellowship: "Nie ma takiego bractwa",
        },
        relativeTime: {
            // Relative time strings - note: these aren't yet implemented in the code
            daysAgo: "dni temu",
            minsAgo: "minut temu",
            hoursAgo: "godzin temu",
            justNow: "teraz",    ////    "właśnie teraz"??? or "w tej chwili" ????
            never: "nigdy",
        },
        home: {
            welcome: "Witaj w Elven Stats!",
            youAreViewing: "Przeglądasz stronę jako {username} // {serverName}",
            youCanChange: "Możesz zmienić Gracza klikając na avatar w prawym górnym rogu -lub- <router-link to='/contact'>odwiedzając tę stronę</router-link>",
            features: {
                headline: "Funkcje",
                fellowshipAdministration: {
                    headline: "Pomoc w zarządzaniu <strong>Bractwem</strong>",
                    bullet1: "Automatyczne śledzenie bonusów produkcji pomoże Ci lepiej zbalansować Twoje Bractwo",
                    bullet2: "Automatyczne generowanie cotygodniowych Raportów, podsumowujących całą aktywność Bractwa: zmiany w punktacji i rankingu, udział w turniejach, informacje o osobistych rekordach oraz \"pochwały\" dla najlepszych",
                    bullet3: "Pomóż członkom Bractwa zorganizować produkcję w ich miastach",
                },
                elvenArchitectIntegration: {
                    headline: "Integracja z <strong>ElvenArchitect</strong>",
                    description: "Przejdź do swojego miasta w ElvenArchitect w kilka sekund! Wykorzystaj to by lepiej rozplanować swoją kolejną przebudowę lub by odkryć, że wolnej przestrzeni masz znacznie więcej, niż myślałeś. Funkcję tę znajdziesz na swojej stronie profilowej, lub stronie dowolnego innego gracza."
                },
                advancedRankingLists: {
                    headline: "Zaawansowane <strong>Rankingi</strong>",
                    bullet1: "Ranking według Mapy, na przykład w Twojej odkrytej okolicy (porównaj swoje postępy z sąsiadami)",
                    bullet2: "Sprawdź postępy, bonusy i wyniki dowolnego gracza.",
                },
                fellowshipTournamentTracking: {
                    headline: "Śledzenie wyników <strong>Turniejów</strong>",
                    description: "Sprawdź jak Twoje Bractwo radzi sobie na tle pozostałych. Wyzwij inne bractwo na przyjacielski pojedynek!",
                },
                matchMaking: {
                    headline: "Znajdź <strong>Dopasowanie</strong>",
                    description: "ElvenStats monitoruje bonusy produkcji graczy oraz balans produkcji wewnątrz bractw.  Bractwo może wykorzystać te informacje by skutecznie ukierunkować rekrutację odpowiednich kandydatów pod kątem usprawnienia wewnętrznej wymiany towarów.  Gracze szukający bractwa mogą ułatwić sobie zadanie zgłaszając się najpierw do bractw, które szukają właśnie nich.  Oszczędność czasu!"
                }
            }
        },
        fellowship: {
            stats: {
                rank: "Ranga",
                points: "Punkty",
                medianUserScore: "Mediana <strong>Wyników</strong>",
                memberCount: "Liczba <strong>Członków</strong>",
            },
            barCharts: {
                clickSlice: "Kliknij wybraną część aby wyświetlić szczegóły",
                tier1: "Podstawowe",
                tier2: "Rzadkie",
                tier3: "Magiczne",
                drillDown: "Wróć do {0}"
            },
            idealCandidate: {
                heading: "Idealny Kandydat",
                description: "To gracz posiadający około {medianScore} punktów oraz przynajmniej jeden z następujących bonusów produkcji: {boosts}.",
                note: "Nie wszystkie kombinacje bonusów są możliwe. Zobacz {0}"
            },
            memberGoodsTable: {
                heading: "Produkcja Towarów",
                description: `Poniższa tabela podsumowuje całkowitą produkcję poszczególnych Towarów wewnątrz Twojego Bractwa.  
                Początkowo, podane wartości szacowane są na podstawie automatycznej obserwacji miast poszczególnych graczy, przy założeniu, że odwiedzają swoje miasto trzykrotnie w ciągu doby (co przekłada się na zbiory: 2x9h oraz 1x3h).  
                Możesz wydatnie zwiększyć dokładność tych wartości, jeśli zapytasz Członków swojego Bractwa o ich codzienne zwyczaje.
                Nie zapomnij zapisać wprowadzanych przez siebie zmian.
                Umieść kursor nas nagłówkiem wybranej kolumny by uzyskać dodatkowe informacje.'
                `,
                refreshButtonText: 'Odśwież Listę',
                refreshButtonTip: 'Kliknięcie spowoduje pełną aktualizację listy.',     //'This will add new members, remove old members, update fellowship roles, and update current scores.',
                inactiveWarningTip: 'Gracz może być nieaktywny, ostatnia aktualizacja: {0}',
                collectsPerDayValidation: "Liczba musi zawierać się w przedziale 1 - 6",
                boostPercentValidation: "Liczba musi zawierać się w przedziale 40 - 700 (nie uwzględniaj bonusu z Górskich Hal)",
                perDayShort: "/dziennie",

                // HIGH PRIORITY - IMPORTANT TOOLTIPS
                scoreTip: "Punkty gracza. Aktualizacja nie następuje w czasie rzeczywistym, ale kilka razy w tygodniu.",
                chapterTip: "Era, w której jest dany gracz, np.: Żywioły = 12, Niziołki = 11, etc.",
                boostTip: "Bonusy oraz wielkość Produkcji w ciągu doby.",
                collectsPerDayTip: `***MOŻESZ EDYTOWAĆ I DOPRECYZOWAĆ*** <br/>
                Częstość Zbiorów. Ile razy w ciągu dnia gracz zbiera towary w swoich manufakturach; dopuszczalne warości to: 1 - 6: <br/>
                    1 = 1x24h,<br/>
                    2 = 2x9h,<br/>
                    3 = 2x9h + 1x3h,<br/>
                    4 = 1x9h + 3x3h,<br/>
                    5 = 4x3h + 1x9h,<br/>
                    6 = 5x3h + 1x9h <BR/>
                Dodatkowe informacje zznajdziesz w FAQ.`,
                relicBoostPercentTip: `***MOŻESZ EDYTOWAĆ I DOPRECYZOWAĆ***<br/>
                Bonus z Reliktów, wartość w przedziale: 40 - 700.  
                Nie uwzględniaj Bonusu z Górskich Hal - ta wartość jest automatycznie wykrywana i dodawana`,
                mountainHallPercentTip: "Automatycznie wykrywany Bonus z Górskich Hal.  Wartość używana łącznie z Bonusem z Reliktów.",
                updatedTip: "Pokazuje jak aktualne (lub nieaktualne) są informacje dotyczące danego gracza.  Ręczne odświeżanie tych informacji nie jest konieczne, gdyż aktualizacja wszystkich danych jest okresowo przeprowadzana automatycznie. Klikając poniższy link można jednak wymusić dowolny dogodny moment aktualizacji.",

            },
            coinsAndSuppliesTable: {
                heading: "Produkcja Złota i Zasobów",
                description: `Kluczową tutaj kolumną jest "Pozostałe Zasoby", pokazująca czy gracz wytwarza wystarczającą ilość Zasobów by utrzymać produkcję w swoich manufakturach przez 24/7.  
                Dzięki przełącznikom zobaczysz wpływ Premii Kultury (Bonus Pomocy Sąsiedzkiej nie jest wliczany) oraz ogólnej aktywności (liczonej jako tzw. Częstość Zbiorów).  
                Zauważ, że całkiem powszechne wśród graczy są ujemne wartości tego wskaźnika.  
                Uzupełniać niedobory diennego zapotrzebowania na Zasoby można na wiele sposobów: Pomoc Sąsiedzka, zaklęcie Mocy Zasobów itd. 
                UWAGA: wydatki na trening jednostek wojskowych nie są obecnie wliczane do wartości tego wskaźnika, dlatego najprawdopodobniej Twoje codzienne wydatki Zasobów będą większe niż prezentowane w tym miejscu wartości.`,

                // These are the column text that show up under the icons. Keep them short.
                minBoostPercent: "Premia",
                made: "Produkowane",
                used: "Zużywane",
                left: "Pozostałe",

                // Low Priority TOOL TIPS
                minimumCultureBoostPercent: "Premia Kultury.  Obliczana wartość obliczana jest bez uwzględniania bonusu Pomocy Sąsiedzkiej.",
                moneyComputedTip: "Całkowita ilość Złota produkowana w Twoim mieście, wliczając Złoto pochodzące z Antycznych Cudów",
                moneyUsedComputedTip: "Ilość Złota zużywana do produkcji Towarów.",
                moneyRemainingComputedTip: "Pozostałe = Produkowane - Zużywane: codzienny nadmiar lub deficyt Złota",
                suppliesComputedTip: "Ilość Zasobów, która byłaby wytworzona gdyby produkcja we wszystkich warsztatach nastawiona była na 1x24h (Skrzynka z narzędziami) + Antyczne Cuda (wyłączając bonusy Zestawów).",
                suppliesUsedComputedTip: "Ilość Zasobów zużywana do produkcji Towarów. Podana wartość nie obejmuje Zasobów zużywanych do innych celów, np. w Barakach.",
                suppliesRemainingComputedTip: "Pozostałe = Produkowane - Zużywane: codzienny nadmiar lub deficyt Zasobów",
                manaTip: "Ilość Many produkowana w ciągu 24 godzin (bez uwzględniania Smoczego Opactwa)",
            },
            popCultureTable: {
                heading: "Populacja i Kultura",
                description: 'Tabela przedstawia szczegółowe wartości Populacji i Kultury. Umieść kursor nad nagłówkami kolumn by uzyskać dodatkowe informacje.',

                // Icon Sub-Headings
                minBoostPercent: "Premia",
                levels: "Poziomy",
                total: "Łączna",
                working: "Pracująca",
                available: "Dostępna",
                required: "Wymagana",

                // Low Priority - Tool Tips
                wonderLevelsTip: "Suma poziomów Antycznych Cudów gracza.",
                cultureBoostPercentTip: "Premia Kultury.  UWAGA: przy obliczaniu wartości Premii nie uwzględnia się wpływu Pomocy Sąsiedzkiej.",
                totalPopulationTip: "Łączna posiadana Populacja, produkowana przez wszystkie rezydencje, budynki kulturowe i Antyczne Cuda",
                workingPopulationTip: "Pracująca Populacja",
                availablePopulationTip: "Dostępna Populacja, to inaczej część Łącznej Populacji, która nie jest potrzebna do pracy",
                totalCultureTip: "Łączna Kultura, produkowana przez wszystkie budynki kulturowe i Antyczne Cuda",
                requiredCultureTip: "Wymagana Kultura",    // "Required Culture needed for all your buildings",
                availableCultureTip: "Dostępna Kultura",
            },
            cityCoverageTable: {
                heading: "Wykorzystanie przestrzeni",
                description: "Pokazuje jak wiele kratek w mieście danego gracza używane jest pod zabudowę przez poszczególny typ budynku",
                tiles: 'Pola'    // 'Kratki' ???
            },

            // HIGH PRIORITY TO TRANSLATE
            weeklyReport: {
                heading: "Tygodniowy Raport",
                description: "Automatycznie generujemy Tygodniowe Raporty z aktywności i rozwoju Twojego Bractwa, które bardzo pomogą Wam wspólnie podsumować każdy kolejny mijający tydzień. Nowy Raport dostępny będzie w każdą niedzielę.",
                selectReportHint: "Wybierz dzień, w którym kończy się Twój Tygodniowy Raport",
                reportsAreOptimizedFor: "Raporty generowane są w formie specjalnie przystosowanej do prawidłowego i wygodnego wyświetlania w systemie wiadomości w grze. Raport zawsze zmieści się w pojedynczej wiadomości.",
                accolades: "pochwały",
                tourneyChamp: " - Mistrz Turnieju (ten tydzień): {0}",
                tourneyHero: " - Bohater Turnieju (ost. 4 tyg.): {0}",
                highestGrowthPlusPercentage: " - Mistrz Rozwoju (pkt & proc.): {0}",
                highestGrowthPoints: " - Mistrz Rozwoju (punktowo): {0}",
                highestGrowthPercentage: " - Mistrz Rozwoju (procentowo): {0}",
                highestGrowthError: " - Mistrz Rozwoju: niewystarczająca ilość danych",
                newPersonalRecords: "Nowe rekordy osobiste",
                userSetANewPersonalRecordFor: " * {0} poprawił swój osobisty rekord! Nowy wynik: {1}",
                allMembersByPointGainThisWeek: "ROZWÓJ, punktowo / procentowo (ten tydzień)",
                tournamentPointsHeader: "TURNIEJ (ten tydzień / łącznie od {0})",
                top8ByPercentage: "TOP 8 Rozwoju, procentowo (ten tydzień)",
                top8ByPointsSince: "TOP 8 Rozwoju, punktowo (od {0})",
                top8ByPercentageSince: "TOP 8 Rozwoju, procentowo (od {0})",
                reportGeneratedBy: "Raport wygenerowany przez elvenstats.com. Więcej znajdziesz tutaj: ",            ////////
                mostPointsInAWeek: "Najwięcej punktów w tygodniu",
                highestTournamentScore: "Najlepszy wynik w turnieju",
                highestTournamentRank: "Najwyższe miejsce w turnieju",
                insufficientHistoryForThesePlayers: "* Pominięto: {0} ze względu na brakujące dane.  Zostaną uwzględnieni w przyszłym tygodniu",
                insufficientHistory1Week: "* Niewystarczająca ilość danych. Sprawdź za tydzień!",
                insufficientHistory4Weeks: "* Niewystarczająca ilość danych. Wymagane są 4 tygodnie śledzenia. Sprawdź wkrótce!",
            },
            memberHistory: {
                heading: "Historia zmian",    //    "Member History",
                noChangesDetected:  "Brak zmian od momentu rozpoczęcia śledzenia: {0}",
            },
            // Medium Priority
            notifications: {
                unsavedChanges: 'Masz niezapisane zmiany. Chcesz je zachować?',
                standbyImporting: 'Proszę czekać. Trwa uzupełnianie brakujących danych',
                limitedHistory: "Od momentu rozpoczęcia zbierania danych {0} upłynęło zbyt mało czasu by móc je obecnie poprawnie zinterpretować. Pełna aktualizacja śledzonych informacji wykonywana jest w każdą niedzielę",
                noChangesSinceTrackingBegan: "Brak zmian",    // "Brak zmian od momentu rozpoczęcia śledzenia",
            }
        },
        player: {
            fellowshipHistory: {
                heading: "Historia zmian bractw"    ////    "Fellowship History"
            }
        },
        status: {
            realTimeUpdatesNotAvailableHeadline: "Aktualizacja w czasie rzeczywistym jest w tej chwili niemożliwa.",
            realTimeUpdatesNotAvailableDescription: "Utrudnienia tego typu zdarzają się zazwyczaj w efekcie chwilowych wyłączeń Serwerów Elvenar, związanych z instalowaniem aktualizacji lub pracami konserwacyjnymi.  Przywrócenie pełnej funkcjonalności ElvenStats będzie możliwe dopiero po zakończeniu tych prac.  Proszę spróbować ponownie w ciągu kilku godzin.  Pozostałe części serwisu działają w tym czasie normalnie.",
            copyToClipboardSuccessful: "Kopiowanie do schowka zakończone powodzeniem!",
            copyToClipboardFailed: "Kopiowanie niudane, spróbuj zaznaczyć cały tekst i nacisnąć CTRL+C",
            errorOccurredImporting: "Błąd importu użytkowników.",
            errorOccurredImportingMessage: "Wystąpił błąd podczas próby importowania użytkowników.  Spróbuj ponownie.  Prosimy o kontakt w przypadku powtórzenia problemu.",
            errorOccurredImportingWillNotBeAvailableInReports: "Niezaimportowani użytkownicy nie będą uwzględniani w raportach.",
            finishedSyncSuccessful: "Synchronizacja zakończona powodzeniem!",
            playerIsAnonymous: "Gracz nie zgodził się na publikację swoich danych",
            inactiveWarningTip: "Gracz może nie być aktywny.  Ostatnia zmiana wyniku: {0}",
            isFriendTip: "Ten Gracz posiada status Przyjaciela ElvenStats,. Przyjaciele to osoby zasłużone dla społeczności ElvenStats, które poświęciły swój czas lub pieniądze by zmienić to miejsce na lepsze!",
        }
    }
}


// WEBPACK FOOTER //
// ./src/lang/pl.js